import { ReactComponent as DeleteIconRed } from '@/../../public/deleteIconRed.svg';
import { ReactComponent as MarkerIconLight } from '@/../../public/markericonlight.svg';
import LaunchIcon from '@mui/icons-material/Launch';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
  Select,
  Snackbar,
  Typography,
} from '@mui/material';
import { SlidersHorizontal, MessageSquare, Layers, Share2 } from 'lucide-react';
import { React, useEffect, useRef, useState } from 'react';
import { useAuth } from './../AuthProvider';
import CustomVestmapViewer from './CustomVestmapViewer';
import CombinedReportViewer from './CombinedReportViewer';
import Header from './layout/Header';
import VestmapLoader from './mongodb/VestmapLoader';
import ErrorPopUp from './pages/BulkVestmaps/ErrorPopUp';
import PlaceComponent from './place.component';
import VestmapViewer from './VestmapViewer';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router-dom';
import { AGENT_ENABLED } from '../featureFlags';

const Content = props => {
  const { getAccessToken, openChangePlan, user } = useAuth();

  // * STATE
  const [bedroom, setBedroom] = useState('Select Bedrooms');
  const [userCredit, setUserCredit] = useState(0);
  const [currentPlan, setCurrentPlan] = useState(() => {
    if (localStorage) {
      const user = JSON.parse(localStorage.getItem('mongodbUser'));
      return user.current_plan;
    }
  });
  const [loaders, setLoaders] = useState([]);

  const [templateID, setTemplateID] = useState({
    _id: 'Default (DISCERN)',
    name: 'Default (DISCERN)',
    rentFlag: true,
  });

  const [viewer, setViewer] = useState(false);
  const [vestmaps, setVestmaps] = useState([]);
  const [currentVestmaps, setCurrentVestmaps] = useState([]);
  const [page, setPage] = useState(1);
  const [failState, setFailState] = useState({ state: false, loaderId: '' });
  const [totalCount, setTotalCount] = useState(0);
  const [loadingState, setLoadingState] = useState({ vestmaps: false });
  const [currentVestmapsLoading, setCurrentVestmapsLoading] = useState(true);
  const [limitError, setLimitError] = useState(false);
  const [errorString, setErrorString] = useState('');
  const [successOpen, setSuccessOpen] = useState(false); // For SnackBar
  const [failOpen, setFailOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false); // For Vestmap Viewer Modal
  const [currentVestmap, setCurrentVestmap] = useState({});
  const sseConnectionRef = useRef(false);
  const [loaderID, setLoaderID] = useState('');
  const [bulkSearches, setBulkSearches] = useState({
    remaining: 0,
    total: 0,
  });
  const [proSearches, setProSearches] = useState({
    remaining: 0,
    total: 0,
  });
  const [expirationDate, setExpirationDate] = useState(null);
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const [arcgisToken, setArcgisToken] = useState(null);
  const [mapsLoading, setMapsLoading] = useState(false);

  const [filterTemplates, setFilterTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [reportFailOpen, setReportFailOpen] = useState(false);

  // Grouping related state
  const [groupedReports, setGroupedReports] = useState([]);
  const [singleReports, setSingleReports] = useState([]);
  const [groupModalOpen, setGroupModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupOptionsModalOpen, setGroupOptionsModalOpen] = useState(false);
  const [combinedReportModalOpen, setCombinedReportModalOpen] = useState(false);
  const minGroupSize = 2; // Minimum number of reports required for grouping

  // * USE EFFECTS
  useEffect(() => {
    let planEventSource = null;
    let syncEventSource = null;

    // Start SSE listeners
    planEventSource = sseListener(); // for normal events
    syncEventSource = syncSSERefresh(); // in case of refresh

    return () => {
      // Cleanup SSE connections
      if (planEventSource) {
        planEventSource.close();
      }
      if (syncEventSource) {
        syncEventSource.close();
      }
    };
  }, []);

  useEffect(() => {
    let eventSource = null;

    if (sseConnectionRef.current) {
      eventSource = computationRefreshSSE();
    }

    return () => {
      if (eventSource) {
        eventSource.close();
      }
    };
  }, []); // Only run once on mount, not on every vestmaps change

  useEffect(() => {}, [currentPlan]);

  useEffect(() => {}, [vestmaps]);

  useEffect(() => {
    if (failState.state) {
      let updatedLoaders = [];
      loaders.forEach(loader => {
        if (loader._id === failState.loaderId) {
          loader.status = 'failed';
        }
        updatedLoaders.push(loader);
      });
      setLoaders(updatedLoaders);
      setFailState({ state: false, loaderId: '' });
    }
  }, [failState]);

  useEffect(() => {
    console.log({ templateID });
  }, [templateID]);

  useEffect(() => {
    // Reset loading states on mount to prevent stale loading states
    setCurrentVestmapsLoading(true);
    setLoaders([]);

    if (localStorage) {
      const user = JSON.parse(localStorage.getItem('mongodbUser'));

      if (!user.current_plan) {
        // update here
        const url =
          process.env.REACT_APP_NODE_URL + '/user_data/update-account';
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAccessToken()}`,
          },

          body: JSON.stringify({
            id: props.userId,
            vestmapToken: getAccessToken(),
          }),
        })
          .then(res => {
            if (res.status === 201) return res.json();
          })
          .then(data => {
            if (data) {
              setCurrentPlan(prev => {
                return data?.mongodbUser.current_plan;
              });

              setBulkSearches(prev => {
                return {
                  remaining: data?.mongodbUser.bulk_searches_remaining,
                  total: data?.mongodbUser.bulk_searches_total,
                };
              });

              setProSearches(prev => {
                return {
                  remaining: data?.mongodbUser.pro_searches_remaining,
                  total: data?.mongodbUser.pro_searches_total,
                };
              });

              setExpirationDate(prev => {
                return data?.mongodbUser.expiration_date;
              });

              if (localStorage) {
                const user = JSON.parse(localStorage.getItem('mongodbUser'));
                user.current_plan = data?.mongodbUser.current_plan;
                user.bulk_searches_remaining =
                  data?.mongodbUser.bulk_searches_remaining;
                user.bulk_searches_total =
                  data?.mongodbUser.bulk_searches_total;
                user.pro_searches_remaining =
                  data?.mongodbUser.pro_searches_remaining;
                user.pro_searches_total = data?.mongodbUser.pro_searches_total;
                user.expiration_date = data?.mongodbUser.expiration_date;
                localStorage.setItem('mongodbUser', JSON.stringify(user));
              }
            }
          })
          .catch(error => {
            console.log('User Account Update Failed');
          });
      }
    }

    getLoaders();
    getVestmapsCount();
    getTemplatesForFilter();
    if (localStorage) {
      setCurrentPlan(prev => {
        const user = JSON.parse(localStorage.getItem('mongodbUser'));
        const plan = user.current_plan;
        return plan;
      });

      setBulkSearches(prev => {
        const user = JSON.parse(localStorage.getItem('mongodbUser'));
        const bulkSearchesRemaining = user.bulk_searches_remaining || 0;
        const bulkSearchesTotal = user.bulk_searches_total || 0;

        return { remaining: bulkSearchesRemaining, total: bulkSearchesTotal };
      });

      setProSearches(prev => {
        const user = JSON.parse(localStorage.getItem('mongodbUser'));
        const proSearchesRemaining = user.pro_searches_remaining || 0;
        const proSearchesTotal = user.pro_searches_total || 0;

        return { remaining: proSearchesRemaining, total: proSearchesTotal };
      });

      setExpirationDate(prev => {
        const user = JSON.parse(localStorage.getItem('mongodbUser'));
        const expirationDate = user.expiration_date || null;
        return expirationDate;
      });
    }
  }, []);

  useEffect(() => {
    vestmapsSetter();
  }, [page]);

  useEffect(() => {
    if (openModal === false) {
      // since the modal is closed, we need to refresh the user's pro searches credit
      setProSearches(prev => {
        const user = JSON.parse(localStorage.getItem('mongodbUser'));
        const proSearchesRemaining = user.pro_searches_remaining || 0;
        const proSearchesTotal = user.pro_searches_total || 0;

        return { remaining: proSearchesRemaining, total: proSearchesTotal };
      });
    }
  }, [openModal]);

  // * FUNCTIONS

  // Group reports by chatID
  const groupReportsByChatID = reports => {
    // First, sort all reports by updated date (newest first)
    const sortedReports = [...reports].sort((a, b) => {
      const dateA = new Date(
        a.updatedAt || a.updated_at || a.createdAt || a.created_at || 0,
      );
      const dateB = new Date(
        b.updatedAt || b.updated_at || b.createdAt || b.created_at || 0,
      );
      return dateB - dateA;
    });

    const groups = {};
    const singles = [];

    sortedReports.forEach(report => {
      if (report?.chatID) {
        if (!groups[report.chatID]) {
          groups[report.chatID] = [];
        }
        groups[report.chatID].push(report);
      } else {
        singles.push(report);
      }
    });

    // Convert groups to array and filter by minimum size
    const groupedArray = Object.entries(groups)
      .filter(([chatID, reports]) => reports.length >= minGroupSize)
      .map(([chatID, reports]) => ({
        chatID,
        reports: reports.sort(
          (a, b) =>
            new Date(
              a.updatedAt || a.updated_at || a.createdAt || a.created_at,
            ) -
            new Date(
              b.updatedAt || b.updated_at || b.createdAt || b.created_at,
            ),
        ),
      }));

    // Reports that should remain single (no chatID or group too small)
    const singleReports = [
      ...singles,
      ...Object.entries(groups)
        .filter(([chatID, reports]) => reports.length < minGroupSize)
        .flatMap(([chatID, reports]) => reports),
    ];

    return { groupedArray, singleReports };
  };

  // * SSE EVENT LISTENER
  function sseListener() {
    const url = process.env.REACT_APP_NODE_URL + '/webhook/planChangeSSE';
    const eventSource = new EventSource(url);

    eventSource.onmessage = event => {
      try {
        const data = JSON.parse(event.data);

        if (data.type === 0) {
        } else if (data.type === 1) {
          setCurrentPlan(prev => {
            return data.newPlan;
          });

          setBulkSearches(prev => {
            return {
              remaining: data.bulk_searches_remaining,
              total: data.bulk_searches_total,
            };
          });

          setProSearches(prev => {
            return {
              remaining: data.pro_searches_remaining,
              total: data.pro_searches_total,
            };
          });

          setExpirationDate(prev => {
            return data.expiration_date;
          });

          if (localStorage) {
            const user = JSON.parse(localStorage.getItem('mongodbUser'));
            user.current_plan = data.newPlan;
            user.bulk_searches_remaining = data.bulk_searches_remaining;
            user.bulk_searches_total = data.bulk_searches_total;
            user.pro_searches_remaining = data.pro_searches_remaining;
            user.pro_searches_total = data.pro_searches_total;
            user.expiration_date = data.expiration_date;
            localStorage.setItem('mongodbUser', JSON.stringify(user));
          }

          eventSource.close();
        }
      } catch (error) {
        console.log('[SSE ERROR]');
        console.log(error);
      }
    };

    return eventSource;
  }

  function computationRefreshSSE() {
    const url =
      process.env.REACT_APP_NODE_URL + '/refresh-sync?userID=' + props.userId;
    const eventSource = new EventSource(url);

    eventSource.onmessage = event => {
      try {
        const data = JSON.parse(event.data);
        console.log(data.type);
        if (data.type === -1) {
          eventSource.close();
        } else if (data.type === 1) {
          const vestmap = data.vestmap;

          if (vestmap._doc) {
            console.log('Vestmap has a _doc field');

            console.log('SSE: ', vestmap._doc.loaderID);
            console.log('SSE: ', vestmap._doc);
            deleteLoader(vestmap._doc.loaderID);
            if (
              !vestmaps.some(v => v._id === vestmap._doc._id) &&
              !currentVestmaps.some(v => v._id === vestmap._doc._id)
            ) {
              setVestmaps([
                { ...vestmap._doc, template: vestmap.template },
                ...vestmaps,
              ]);
              setCurrentVestmaps([
                { ...vestmap._doc, template: vestmap.template },
                ...currentVestmaps,
              ]);
            }
          } else {
            console.log('Vestmap does not have a _doc field');

            console.log('SSE: ', vestmap.loaderID);
            console.log('SSE: ', vestmap);
            deleteLoader(vestmap.loaderID);
            if (
              !vestmaps.some(v => v._id === vestmap._id) &&
              !currentVestmaps.some(v => v._id === vestmap._id)
            ) {
              setVestmaps([vestmap, ...vestmaps]);
              setCurrentVestmaps([vestmap, ...currentVestmaps]);
            }
          }

          eventSource.close();
        } else if (data.type === -2) {
          setLoaders(prev =>
            prev.map(el =>
              el._id === data.loaderID ? { ...el, status: 'failed' } : el,
            ),
          );
          setFailOpen(true);
          setFailState({ state: true, loaderId: data.loaderID });

          eventSource.close();
        }
      } catch (error) {
        console.log('[ComputationRefreshSSE ERROR]');
        console.log(error);
      }
    };

    // Return the eventSource for cleanup
    return eventSource;
  }

  function syncSSERefresh() {
    const url =
      process.env.REACT_APP_NODE_URL +
      '/webhook/planChangeSyncSSE?currentPlan=' +
      currentPlan +
      '&userID=' +
      props.userId;

    const eventSource = new EventSource(url);
    eventSource.onmessage = event => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === 0) {
        } else if (data.type === 1) {
          setCurrentPlan(prev => {
            return data.newPlan;
          });
          setBulkSearches(prev => {
            return {
              remaining: data.bulk_searches_remaining,
              total: data.bulk_searches_total,
            };
          });

          setProSearches(prev => {
            return {
              remaining: data.pro_searches_remaining,
              total: data.pro_searches_total,
            };
          });

          setExpirationDate(prev => {
            return data.expiration_date;
          });

          if (localStorage) {
            const user = JSON.parse(localStorage.getItem('mongodbUser'));
            user.current_plan = data.newPlan;
            user.bulk_searches_remaining = data.bulk_searches_remaining;
            user.bulk_searches_total = data.bulk_searches_total;
            user.pro_searches_remaining = data.pro_searches_remaining;
            user.pro_searches_total = data.pro_searches_total;
            user.expiration_date = data.expiration_date;
            localStorage.setItem('mongodbUser', JSON.stringify(user));
          }

          eventSource.close();
        }
      } catch (error) {
        console.log('[SyncSSERefresh ERROR]');
        console.log(error);
      }
    };

    return eventSource;
  }

  // insert items into array at index
  const insertAtIndex = (arr, index, newItems) => {
    if (index > arr.length) {
      // If index is beyond the array's length, fill with nulls
      const fillCount = index - arr.length;
      const filler = new Array(fillCount).fill(null);

      return [...arr, ...filler, ...newItems];
    }

    return [...arr.slice(0, index), ...newItems, ...arr.slice(index)];
  };

  // Adds a new loader into the db and returns its id
  const addLoader = async (new_address, bedroom) => {
    // create a proper url using Query String
    const url = new URL(process.env.REACT_APP_NODE_URL + '/vestmap_loader/add');
    const params = {
      userid: props.userId,
      address: new_address,
      ...(templateID.rentFlag && { bedroom: bedroom }),
    };
    url.search = new URLSearchParams(params).toString();

    console.log('URL: ', url);
    // return;
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',

        Authorization: `Bearer ${getAccessToken()}`,
      },
    });
    const data = await response.json();
    setUserCredit(userCredit - 1);
    return data.insertedId;
  };

  async function getTemplatesForFilter() {
    try {
      const url =
        process.env.REACT_APP_NODE_URL + '/templates/filter/' + props.userId;
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
      const data = await response.json();
      setFilterTemplates(data);
    } catch (error) {
      console.log(error);
    }
  }

  const getVestmaps = async (requiredPage, previousVestmaps) => {
    const pg = requiredPage || page;
    const position = (pg - 1) * 24; // Increased from 12 to 24 to account for grouping
    if (totalCount > 0 && position >= totalCount)
      return console.log('[No More Vestmaps]');
    if (vestmaps[position] != null) return console.log('[Already Loaded]');
    const url =
      process.env.REACT_APP_NODE_URL +
      '/vestmaps_page?userid=' +
      props.userId +
      '&page=' +
      pg +
      '&perPage=24'; // Request 24 reports per page instead of default 12
    try {
      setLoadingState({ ...loadingState, vestmaps: true });
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
      const parsedRes = await response.json();

      if (!parsedRes.status)
        throw new Error('Something went wrong. Please try again later.');
      const newVestmaps = parsedRes.result;
      console.log({ newVestmaps });
      const prevs = previousVestmaps || vestmaps;
      const total = insertAtIndex(prevs, position, newVestmaps);
      setVestmaps(prev => {
        sseConnectionRef.current = true;
        return total;
      });

      return total;
    } catch (error) {
      window.alert(error.message);
    } finally {
      setLoadingState({ ...loadingState, vestmaps: false });
    }
  };

  const vestmapsSetter = async () => {
    setCurrentVestmapsLoading(true);

    try {
      const skip = (page - 1) * 12;
      // Fetch more reports to account for grouping - aim for 4 rows (12 visual boxes)
      const targetVisualCount = 12;
      const fetchCount = Math.max(12, targetVisualCount * 2); // Fetch at least 24 reports to ensure enough visual content
      const currents = vestmaps.slice(skip, skip + fetchCount);
      const nullChecker = arr => arr.every(el => el == null);
      let newList;

      if (currents.length != 0 && !nullChecker(currents)) {
        setCurrentVestmaps(currents);
      } else {
        newList = await getVestmaps();
        const newCurrents = newList.slice(skip, skip + fetchCount);
        setCurrentVestmaps(newCurrents);
      }

      // Set loading to false after main data is loaded
      setCurrentVestmapsLoading(false);

      // Prefetch next page in background (don't let this affect loading state)
      try {
        await getVestmaps(page + 1, newList);
      } catch (error) {
        console.error('Background prefetch failed:', error);
        // Don't reset loading state here as main data is already loaded
      }
    } catch (error) {
      console.error('Error in vestmapsSetter:', error);
      // Always reset loading state, even on error
      setCurrentVestmapsLoading(false);
    }
  };

  const getVestmapsCount = async () => {
    const url =
      process.env.REACT_APP_NODE_URL +
      '/vestmap_total_count?userid=' +
      props.userId;
    try {
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
      const parsedRes = await response.json();
      if (!parsedRes.status)
        throw new Error('Something went wrong. Please try again later.');
      console.log({ parsedRes });
      setTotalCount(parsedRes.total_count);
    } catch (error) {
      window.alert(error.message);
    }
  };

  function closeLimitError() {
    setLimitError(false);
  }

  // whenever a loader is added start working on it
  const computeVestmap = async (new_address, bedroom, newLoader) => {
    if (newLoader.status === 'failed') {
      let updatedLoaders = [];
      loaders.forEach(loader => {
        if (loader._id === newLoader._id) {
          loader.status = 'active';
        }
        updatedLoaders.push(loader);
      });
      setLoaders(updatedLoaders);
    }

    const url = new URL(
      process.env.REACT_APP_NODE_URL + '/revamped-compute-vestmap',
    );

    const params = {
      address: new_address,
      ...(templateID.rentFlag && { bedroom: bedroom }),
      api: 'iggouwBhfAl8HuhoRjx',
      userid: props.userId,
      vestmap_loader: newLoader._id,
      ...(templateID && { templateID: templateID._id }),
    };

    url.search = new URLSearchParams(params).toString();

    try {
      setLoaderID(prev => newLoader._id);
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
      const data = await response.json();

      console.log({
        revamp_res: data,
      });

      if (response.status === 401) {
        setErrorString('Your plan has expired.');
        setLimitError(true);
        throw new Error('Your plan has expired.');
      }

      // This will show any error logs passed from the backend
      if (response.status === 500) {
        if (data.message) {
          console.log('Setting snackbar alert message');
          setErrorMessage(data.message);
        }
        throw new Error('Report Failed');
      }

      if (!data.status)
        throw new Error('Something went wrong. Please try again later.');

      // Remove the loader and add the vestmap
      deleteLoader(newLoader._id);
      setVestmaps(prev => {
        return [data.vestmap_json, ...prev];
      });

      setCurrentVestmaps(prev => {
        return [data.vestmap_json, ...prev];
      });

      setSuccessOpen(true);
    } catch (error) {
      console.log('Report failed. Showing snackbar...');
      setReportFailOpen(true);
      setFailState({ state: true, loaderId: newLoader._id });
    }
  };

  // This method fetches the specified loader from the database
  const getLoader = async loaderId => {
    const url =
      process.env.REACT_APP_NODE_URL + `/vestmap_loader/id?loader=${loaderId}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAccessToken()}`,
      },
    });
    const data = await response.json();
    return data[0];
  };

  const getLoaders = async () => {
    let MongodbUserID = props.userId;
    if (MongodbUserID) {
      let url =
        process.env.REACT_APP_NODE_URL +
        '/vestmap_loader?userid=' +
        MongodbUserID;
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
      if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        window.alert(message);
        return;
      }
      const loaders = await response.json();
      console.log({ loaders });
      setLoaders(loaders);
    }
  };

  async function deleteLoader(id) {
    try {
      console.log('Deleting Loader: ', id);
      if (!id) return;

      // Delete from database
      let url =
        process.env.REACT_APP_NODE_URL + `/vestmaps_loader/delete?id=${id}`;
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
      if (!res.ok) {
        setFailOpen(true);
        return;
      }

      // Remove from state
      const newLoaders = loaders.filter(el => el?._id !== id);
      setLoaders(prev => newLoaders);
    } catch (error) {
      console.log('Error in deleteLoader');
      console.log(error);
    }
  }

  async function deleteVestmap(id) {
    try {
      console.log('Deleting Vestmap: ', id);

      // Delete from database
      const url = process.env.REACT_APP_NODE_URL + `/delete-vestmap/${id}`;
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
      if (!response.ok) {
        setFailOpen(true);
        return;
      }
      const data = await response.json();
      console.log(data);

      // Remove from state
      const newVestmaps = vestmaps.filter(vestmap => vestmap?._id !== id);
      setVestmaps(newVestmaps);
      const newCurrentVestmaps = currentVestmaps.filter(
        vestmap => vestmap?._id !== id,
      );
      setCurrentVestmaps(newCurrentVestmaps);
    } catch (error) {
      console.log(error);
    }
  }

  // Vestmap Create
  const RecordCreate = async () => {
    if (templateID.rentFlag) {
      if (bedroom === 'Select Bedrooms') {
        alert('Must Select Bedrooms');
        return;
      }
    }

    let new_address = document.getElementById('address').value;

    console.log('New Address: ', new_address);

    if (new_address === '') {
      alert('Must Add an address');
      return;
    }
    document.getElementById('address').value = '';

    const loaderId = await addLoader(new_address, bedroom);

    // return;
    const newLoader = await getLoader(loaderId);
    setLoaders([newLoader, ...loaders]);
    await computeVestmap(new_address, bedroom, newLoader);
  };

  useEffect(() => {
    console.log({ loaders });
  }, [loaders]);

  const modifyVestmap = newVestmap => {
    try {
      console.log('Modifying Vestmap: ', newVestmap);
      let newVestmaps = [];

      setVestmaps(prev => prev.filter(el => el != null));

      vestmaps.forEach(vestmap => {
        if (vestmap._id === newVestmap._id) {
          newVestmaps.push(newVestmap);
        } else {
          newVestmaps.push(vestmap);
        }
      });
      setVestmaps(newVestmaps);

      let newCurrentVestmaps = [];
      currentVestmaps.forEach(vestmap => {
        if (vestmap._id === newVestmap._id) {
          newCurrentVestmaps.push(newVestmap);
        } else {
          newCurrentVestmaps.push(vestmap);
        }
      });
      setCurrentVestmaps(newCurrentVestmaps);
      console.log('Vestmap Modified');
    } catch (error) {
      console.log('Error in modifyVestmap');
      console.log(error);
    }
  };

  const [pdfGenError, setPdfGenError] = useState(false);
  const [proGenError, setProGenError] = useState(false);

  const openSnackbar = status => {
    if (status === 'success') {
      setSuccessOpen(true);
    } else if (status === 'pdf') {
      setPdfGenError(true);
    } else if (status === 'pro') {
      setProGenError(true);
    } else {
      setFailOpen(true);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessOpen(false);
    setFailOpen(false);

    setPdfGenError(false);
    setProGenError(false);
  };

  const handleReportSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setReportFailOpen(false);
    setErrorMessage(null);
  };

  const handleModalOpen = record => {
    setCurrentVestmap(prev => {
      return record;
    });
    setOpenModal(true);
    setViewer(true);
  };

  const handleGroupViewAll = group => {
    setSelectedGroup(group);
    setGroupOptionsModalOpen(true);
  };

  const handleIndividualReports = () => {
    setGroupOptionsModalOpen(false);
    setGroupModalOpen(true);
  };

  const handleCombinedReport = () => {
    setGroupOptionsModalOpen(false);
    setCombinedReportModalOpen(true);
  };

  const closeViewer = state => {
    setViewer(state);
  };

  function setSideBarState(state) {
    setIsSideBarOpen(state);
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleFilterClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = templateID => {
    console.log({ templateID });
    if (templateID.type === 'click') {
      setSelectedTemplate(null);
      setAnchorEl(null);
      return;
    }
    setSelectedTemplate(templateID);
    setAnchorEl(null);
  };

  useEffect(() => {
    console.log({ selectedTemplate });
  }, [selectedTemplate]);

  // Process reports for grouping when currentVestmaps changes
  useEffect(() => {
    if (currentVestmaps.length > 0) {
      const { groupedArray, singleReports } =
        groupReportsByChatID(currentVestmaps);
      setGroupedReports(groupedArray);
      setSingleReports(singleReports);
    } else {
      setGroupedReports([]);
      setSingleReports([]);
    }
  }, [currentVestmaps]);

  async function getTemplates() {
    try {
      const user = JSON.parse(localStorage.getItem('mongodbUser'));
      if (!user) throw new Error('User not found in localstorage');

      const url =
        process.env.REACT_APP_NODE_URL + '/templates/' + user._id + '?option=2';
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });

      const data = await res.json();

      // Reorder templates to put "Default (DISCERN)" first
      const reorderedData = [...data].sort((a, b) => {
        if (a.templateName === 'Default (DISCERN)') return -1;
        if (b.templateName === 'Default (DISCERN)') return 1;
        return 0;
      });

      setTemplates(reorderedData);
      setTemplateID({
        _id: reorderedData[0]._id,
        name: reorderedData[0].templateName,
        theme: reorderedData[0].theme,
        rentFlag:
          reorderedData[0]?.sections.some(section => section.key === 'rent') ||
          false,
      });
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (user) {
      getTemplates();
    }
  }, [user]);

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          paddingX: {
            md: '1.25rem',
            xs: '0',
          },
        }}
      >
        {viewer ? null : (
          <Header
            sideBarState={setSideBarState}
            pageTitle={'My Reports'}
            templateID={templateID}
            setTemplateID={setTemplateID}
          />
        )}
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          paddingY: '1rem',
          paddingX: '1.25rem',
          transition: 'all 0.3s ease',
          transform:
            isSideBarOpen == true ? 'translateX(60%)' : 'translateX(0)',
        }}
      >
        <Container
          sx={{
            display: {
              md: 'none',
              xs: 'flex',
            },
            paddingBottom: '1rem',
          }}
        >
          <Typography
            sx={{
              color: '#39585C',
              fontFamily: 'Lato',
              fontSize: '1.5rem',
              fontStyle: 'normal',
              fontWeight: '800',
              lineHeight: '130%',
            }}
          >
            Run Report
          </Typography>
        </Container>

        <Box
          sx={{
            paddingX: '1.2%',
          }}
        >
          {limitError && (
            <ErrorPopUp closeLimitError={closeLimitError} error={errorString} />
          )}
          <Snackbar
            open={successOpen}
            autoHideDuration={1000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={handleClose}
              severity='success'
              sx={{ width: '100%' }}
            >
              Success!
            </Alert>
          </Snackbar>
          <Snackbar
            open={failOpen}
            autoHideDuration={1000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={handleClose}
              severity='error'
              sx={{ width: '100%' }}
            >
              Sorry an error occured. Please try again later.
            </Alert>
          </Snackbar>

          <Snackbar
            open={reportFailOpen}
            autoHideDuration={null}
            onClose={handleReportSnackbarClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={handleReportSnackbarClose}
              severity='error'
              sx={{ width: '100%' }}
            >
              {errorMessage ||
                'Sorry an error occured. Please try again later.'}
            </Alert>
          </Snackbar>

          <Snackbar
            open={pdfGenError}
            autoHideDuration={1000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity='error'
              sx={{ width: '100%' }}
            >
              Sorry an error occured while generating the PDF. Please try again
            </Alert>
          </Snackbar>

          <Snackbar
            open={proGenError}
            autoHideDuration={1000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity='error'
              sx={{ width: '100%' }}
            >
              Sorry an error occured while generating the Pro Report. Please try
            </Alert>
          </Snackbar>

          <Box
            sx={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              flexWrap: {
                xs: 'wrap',
                sm: 'nowrap',
              },
            }}
          >
            <Grid
              md={5}
              sx={{
                padding: '1rem',
                borderRadius: '1.25rem',
                flexGrow: 1,
                border: '1px solid #EDF2F7',
                display: {
                  xs: 'block',
                  sm: 'none',
                },
              }}
            >
              <Select
                value={templateID?._id}
                onChange={e =>
                  setTemplateID({
                    _id: e.target.value,
                    name: templates.find(
                      template => template._id === e.target.value,
                    )?.templateName,
                    theme: templates.find(
                      template => template._id === e.target.value,
                    )?.theme,
                    rentFlag:
                      templates
                        .find(template => template._id === e.target.value)
                        ?.sections.some(section => section.key === 'rent') ||
                      false,
                  })
                }
                sx={{
                  width: '100%',
                  borderRadius: '1rem',
                  fontWeight: '800',
                  height: '100%',
                  fontSize: '0.875rem',
                  '@media (min-width: 600px) and (max-width: 900px)': {
                    fontSize: '0.70rem',
                  },
                  '@media (min-width: 900px) and (max-width: 1200px)': {
                    fontSize: '0.60rem',
                  },
                }}
                labelId='templates'
                placeholder='Default (DISCERN)'
              >
                {templates.map(template => (
                  <MenuItem key={template._id} value={template._id}>
                    <Box
                      sx={{
                        fontFamily: 'Lato',
                        fontSize: '1rem',
                        padding: '0.1rem 0.25rem 0.1rem 0.25rem',
                        borderRadius: '0.5rem',
                        textAlign: 'center',
                        ...(template?.theme && template.theme),
                      }}
                    >
                      {template.templateName}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid
              md={5}
              sx={{
                padding: '1rem',
                borderRadius: '1.25rem',
                flexGrow: 1,
                border: '1px solid #EDF2F7',
              }}
            >
              {/* Search Bar  */}
              <Grid
                container
                spacing={0}
                display={'flex'}
                sx={{
                  flexDirection: {
                    xs: 'column',
                    sm: 'row',
                  },

                  gap: {
                    sm: '0',
                    xs: '1rem',
                  },
                }}
              >
                <Grid xs={12} sm={templateID.rentFlag ? 8 : 12}>
                  <PlaceComponent />
                </Grid>

                {templateID.rentFlag && (
                  <Grid
                    xs={12}
                    sm={4}
                    sx={{
                      paddingX: '1%',
                    }}
                  >
                    <Select
                      value={bedroom}
                      onChange={e => setBedroom(e.target.value)}
                      sx={{
                        width: '100%',
                        borderRadius: '1rem',
                        fontWeight: '800',
                        height: '100%',
                        fontSize: '0.875rem',
                        '@media (min-width: 600px) and (max-width: 900px)': {
                          fontSize: '0.70rem',
                        },
                        '@media (min-width: 900px) and (max-width: 1200px)': {
                          fontSize: '0.60rem',
                        },
                      }}
                      labelId='bedrooms'
                      placeholder='Select Bedrooms'
                    >
                      <MenuItem value='Select Bedrooms'>
                        Select Bedrooms
                      </MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                    </Select>
                  </Grid>
                )}
              </Grid>

              {/* Button */}
              <Grid
                container
                spacing={0}
                sx={{
                  marginTop: '1rem',
                }}
              >
                <Button
                  sx={{
                    width: '100%',
                    borderRadius: '0.75rem',
                    '&:hover': {
                      bgcolor: '#39585C',
                      color: '#FFF',
                      border: '1px solid #4FA490',
                    },
                    '& svg': {
                      height: '1.25rem',
                      width: '1.25rem',
                    },
                    border: '1px solid #FFFFFF',
                    fontSize: '1rem',
                    bgcolor: '#4FA490',
                    color: '#FFFFFF',
                    padding: '2%',
                    textTransform: 'capitalize',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    fontFamily: "'Lato', sans-serif",
                    position: 'relative', // Make the button a positioned element
                  }}
                  onClick={RecordCreate}
                >
                  <MarkerIconLight />
                  <span>VESTMAP IT</span>
                </Button>
              </Grid>
            </Grid>

            {/* Right Half */}
            <Grid
              container
              md={5}
              sx={{
                padding: '1rem',
                flexGrow: 1,
                borderRadius: '1.25rem',
                border: '1px solid #EDF2F7',
                display: {
                  sm: 'none',
                  md: 'grid',
                },
              }}
            >
              <Grid
                sx={{
                  fontFamily: 'Lato',
                  fontSize: '1.125rem',
                  fontStyle: 'normal',
                  fontWeight: '800',
                  lineHeight: '135%',
                  letterSpacing: '0.0125rem',
                  color: '#1A202C',
                }}
              >
                Searches Remaining
              </Grid>
              <Box
                sx={{
                  padding: '1rem',
                  paddingX: {
                    md: '0',
                    xs: '0',
                  },

                  display: 'flex',
                  width: '100%',
                  gap: '1rem',
                }}
              >
                <Grid
                  md={7}
                  xs={6}
                  sx={{
                    borderRadius: '1.25rem',
                    padding: '1rem',
                    textAlign: 'center',
                    border: '1px solid #EDF2F7',
                    display: 'flex',
                    fontSize: {
                      xs: '0.8rem',
                      sm: '1rem',
                    },
                    flexDirection: 'column',
                    justifyContent: 'center', // todo - remove when bulk searches integrated
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: {
                        xs: 'column',
                        sm: 'row',
                      },
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>Pro Searches:</Box>
                    <Box
                      sx={{
                        fontFamily: 'Lato',

                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '150%',
                        letterSpacing: '0.0125rem',
                        color: '#1A202C',
                      }}
                    >
                      {proSearches.remaining} / {proSearches.total}
                    </Box>
                  </Box>

                  {/* <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      flexDirection: {
                        xs: 'column',
                        sm: 'row',
                      },
                    }}
                  >
                    <Box>Bulk Searches:</Box>
                    <Box
                      sx={{
                        fontFamily: 'Lato',

                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '150%',
                        letterSpacing: '0.0125rem',
                        color: '#1A202C',
                      }}
                    >
                      {bulkSearches.remaining} / {bulkSearches.total}
                    </Box>
                  </Box> */}
                </Grid>
                <Grid
                  xs={6}
                  md={5}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    sx={{
                      width: '100%',
                      borderRadius: '12px',
                      '&:hover': {
                        bgcolor: '#39585C',
                        color: '#FFF',
                        border: '1px solid #4FA490',
                      },
                      bgcolor: '#4FA490',
                      color: '#FFFFFF',
                      padding: '10px',
                      textTransform: 'capitalize',
                      fontWeight: '700',
                      fontSize: {
                        xs: '0.8rem',
                        sm: '0.9rem',
                      },

                      display: 'flex',
                      justifyContent: 'center',
                      gap: '2px',
                      fontFamily: '"Lato",sans-serif',
                    }}
                    startIcon={<OpenInNewIcon />}
                    onClick={openChangePlan}
                  >
                    <span>Get More Searches</span>
                  </Button>
                </Grid>
              </Box>
            </Grid>
          </Box>
          <Box
            sx={{
              borderRadius: '1rem',
              border: '1px solid #EDF2F7',
              marginTop: '2rem',
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Lato',
                  fontSize: '1.5rem',
                  fontStyle: 'normal',
                  fontWeight: '800',
                  lineHeight: '135%',
                  letterSpacing: '0.0125rem',
                  padding: '1rem',
                  color: '#1A202C',
                }}
              >
                My VestMaps
              </Typography>

              <>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '.65rem',
                      padding: '.75rem 1rem',
                      border: '3px solid #212529',
                      borderRadius: '0.65rem',
                      cursor: 'pointer',
                    }}
                    onClick={handleFilterClick}
                  >
                    <SlidersHorizontal strokeWidth={2.5} />
                    <Typography
                      sx={{
                        fontFamily: 'Lato',
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        lineHeight: '1.3125rem',
                        letterSpacing: '0.0125rem',
                        textAlign: 'left',
                      }}
                    >
                      Filter by Template
                    </Typography>
                  </Box>
                </Box>

                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleFilterClose}
                  PaperProps={{
                    style: {
                      maxHeight: 200, // Customize the height if needed
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleFilterClose({ type: 'click' });
                    }}
                    sx={{
                      backgroundColor:
                        selectedTemplate === null ? '#f0f0f0' : 'inherit',
                    }}
                  >
                    None
                  </MenuItem>
                  {filterTemplates.map((template, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => {
                        handleFilterClose(template._id);
                      }}
                      sx={{
                        backgroundColor:
                          template._id === selectedTemplate
                            ? '#f0f0f0'
                            : 'inherit',
                      }}
                    >
                      {template.templateName}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            </Grid>
            <Grid
              container
              sx={{
                marginTop: '1rem',
                paddingX: '1rem',
              }}
            >
              {/* Render vestmaps if not loading or loading complete*/}
              {!currentVestmapsLoading &&
                (currentVestmaps.length > 0 || loaders.length !== 0) && (
                  <div className='divvy-div'>
                    {/* Render loaders first */}
                    {loaders.map(item => {
                      if (
                        item?.status === 'active' ||
                        item?.status === 'failed'
                      ) {
                        return (
                          <VestmapLoader
                            loader={item}
                            computeVestmap={computeVestmap}
                            deleteLoader={deleteLoader}
                            key={item._id}
                          />
                        );
                      }
                      return null;
                    })}

                    {/* Render all vestmaps in chronological order */}
                    {(() => {
                      // Create a combined list of all vestmaps with their type and updated date
                      const allVestmaps = [];

                      // Add grouped reports
                      groupedReports
                        .filter(
                          group =>
                            selectedTemplate === null ||
                            group.reports.some(
                              report => selectedTemplate === report?.templateID,
                            ),
                        )
                        .forEach(group => {
                          const latestReport = group.reports[0];
                          allVestmaps.push({
                            type: 'grouped',
                            data: group,
                            updatedAt:
                              latestReport?.updatedAt ||
                              latestReport?.updated_at ||
                              latestReport?.createdAt ||
                              latestReport?.created_at ||
                              0,
                          });
                        });

                      // Add single reports
                      singleReports
                        .filter(
                          item =>
                            selectedTemplate === item?.templateID ||
                            selectedTemplate === null,
                        )
                        .forEach(item => {
                          allVestmaps.push({
                            type: 'single',
                            data: item,
                            updatedAt:
                              item?.updatedAt ||
                              item?.updated_at ||
                              item?.createdAt ||
                              item?.created_at ||
                              0,
                          });
                        });

                      // Sort by updated date (newest first)
                      allVestmaps.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
                      );

                      // Render in chronological order
                      return allVestmaps.map((vestmap, index) => {
                        if (vestmap.type === 'grouped') {
                          return (
                            <GroupedVestmapBox
                              key={vestmap.data.chatID}
                              group={vestmap.data}
                              handleModalOpen={handleModalOpen}
                              handleDeleteVestmap={deleteVestmap}
                              onViewAll={handleGroupViewAll}
                            />
                          );
                        } else {
                          return (
                            <VestmapBox
                              record={vestmap.data || null}
                              handleModalOpen={handleModalOpen}
                              id={vestmap.data?._id}
                              key={vestmap.data?._id}
                              handleDeleteVestmap={deleteVestmap}
                            />
                          );
                        }
                      });
                    })()}
                  </div>
                )}

              {/* Render loaders when initial loading */}
              {currentVestmapsLoading && (
                <div className='divvy-div'>
                  {Array.from({ length: 12 }, (_, i) => (
                    <VestmapLoader loader={{ status: 'active' }} />
                  ))}
                </div>
              )}

              {!currentVestmapsLoading &&
                currentVestmaps.length === 0 &&
                loaders.length === 0 && (
                  <Box
                    sx={{
                      paddingLeft: '7%',
                      height: '20rem',
                      width: '70%',
                      position: 'relative',
                    }}
                  >
                    {isVideoLoading && (
                      <CircularProgress
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          color: '#39585C',
                        }}
                      />
                    )}
                    <iframe
                      src='https://www.loom.com/embed/25e783d1638d48e09d5b562a414185a8?sid=82f592bc-ac94-459a-9a99-ed8b2eea892e'
                      frameBorder='0'
                      webkitAllowFullScreen
                      mozAllowFullScreen
                      allowFullScreen
                      onLoad={() => setIsVideoLoading(false)}
                      style={{
                        height: '100%',
                        width: '100%',
                        display: isVideoLoading ? 'none' : 'block',
                      }}
                      title='Vestmap Video Tutorial'
                    ></iframe>
                  </Box>
                )}
            </Grid>
            <Grid marginY={'1rem'}>
              <ul className='pagination'>
                {Array.from(
                  { length: Math.max(1, Math.ceil(totalCount / 24)) },
                  (_, i) => (
                    <li key={i}>
                      <button
                        onClick={() => !loadingState.vestmap && setPage(i + 1)}
                        style={{
                          backgroundColor: page === i + 1 ? '#39585c' : '#fff',
                          color: page === i + 1 ? '#fff' : '#000',
                          cursor: 'pointer',
                        }}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ),
                )}
              </ul>
            </Grid>
          </Box>
        </Box>
        {viewer &&
          (currentVestmap?.isNewSchema ? (
            <CustomVestmapViewer
              open={openModal}
              setOpen={setOpenModal}
              viewerState={closeViewer}
              vestmapData={currentVestmap}
              openSnackbar={openSnackbar}
              modifyVestmap={modifyVestmap}
              mapsLoading={mapsLoading}
              setMapsLoading={setMapsLoading}
              arcgisToken={arcgisToken}
            />
          ) : (
            <VestmapViewer
              open={openModal}
              setOpen={setOpenModal}
              viewerState={closeViewer}
              vestmapData={currentVestmap}
              openSnackbar={openSnackbar}
              modifyVestmap={modifyVestmap}
            />
          ))}

        {/* Group Options Modal */}
        <Dialog
          open={groupOptionsModalOpen}
          onClose={() => setGroupOptionsModalOpen(false)}
          maxWidth='sm'
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '1.25rem',
              padding: '1rem',
            },
          }}
        >
          <DialogTitle
            sx={{
              textAlign: 'center',
              borderBottom: '1px solid #e5e7eb',
              paddingBottom: '1rem',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Lato',
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1f2937',
              }}
            >
              View Group Reports
            </Typography>
          </DialogTitle>
          <DialogContent
            sx={{
              padding: '2rem 1rem',
              textAlign: 'center',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Lato',
                fontSize: '1rem',
                color: '#6b7280',
                marginBottom: '2rem',
                lineHeight: '1.5',
              }}
            >
              Choose how you'd like to view the reports for{' '}
              <strong>
                {selectedGroup?.reports?.[0]?.address_info?.address ||
                  selectedGroup?.reports?.[0]?.addressInfo?.address ||
                  'this chat session'}
              </strong>
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                marginTop: '1rem',
              }}
            >
              <Button
                onClick={handleIndividualReports}
                variant='outlined'
                size='large'
                sx={{
                  border: '2px solid #39585C',
                  borderRadius: '0.75rem',
                  color: '#39585C',
                  textTransform: 'capitalize',
                  fontFamily: '"Lato", sans-serif',
                  fontSize: '1rem',
                  fontWeight: '600',
                  padding: '1rem',
                  '&:hover': {
                    border: '2px solid #39585C',
                    bgcolor: '#39585C',
                    color: 'white',
                  },
                }}
              >
                Individual Reports
              </Button>

              <Button
                onClick={handleCombinedReport}
                variant='outlined'
                size='large'
                sx={{
                  border: '2px solid #4FA490',
                  borderRadius: '0.75rem',
                  color: '#4FA490',
                  textTransform: 'capitalize',
                  fontFamily: '"Lato", sans-serif',
                  fontSize: '1rem',
                  fontWeight: '600',
                  padding: '1rem',
                  '&:hover': {
                    border: '2px solid #4FA490',
                    bgcolor: '#4FA490',
                    color: 'white',
                  },
                }}
              >
                Combined Report
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Combined Report Viewer */}
        <CombinedReportViewer
          open={combinedReportModalOpen}
          setOpen={setCombinedReportModalOpen}
          groupData={selectedGroup}
          openSnackbar={openSnackbar}
          modifyVestmap={modifyVestmap}
          viewerState={closeViewer}
          publicView={false}
        />

        {/* Group Modal */}
        <Dialog
          open={groupModalOpen}
          onClose={() => setGroupModalOpen(false)}
          maxWidth='xl'
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '1.25rem',
              maxHeight: '90vh',
              minHeight: '60vh',
            },
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #e5e7eb',
              paddingBottom: '1rem',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Lato',
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1f2937',
              }}
            >
              {selectedGroup?.reports?.[0]?.address_info?.address ||
                selectedGroup?.reports?.[0]?.addressInfo?.address ||
                'Chat Session Reports'}
            </Typography>
            <Button
              onClick={() => setGroupModalOpen(false)}
              sx={{
                minWidth: 'auto',
                padding: '8px',
                borderRadius: '50%',
                color: '#6b7280',
                '&:hover': {
                  backgroundColor: '#f3f4f6',
                },
              }}
            >
              ✕
            </Button>
          </DialogTitle>
          <DialogContent
            sx={{
              padding: '2rem',
              overflow: 'auto',
            }}
          >
            {selectedGroup && (
              <div className='divvy-div'>
                {selectedGroup.reports.map((report, index) => (
                  <VestmapBox
                    key={report._id}
                    record={report}
                    handleModalOpen={handleModalOpen}
                    id={report._id}
                    handleDeleteVestmap={deleteVestmap}
                  />
                ))}
              </div>
            )}
          </DialogContent>
        </Dialog>
      </Box>
    </Box>
  );
};

const GroupedVestmapBox = props => {
  const navigate = useNavigate();
  const { group, handleModalOpen, handleDeleteVestmap } = props;
  const latestReport = group.reports[0];

  const handleOpenChat = () => {
    navigate(`/agent?chatID=${group.chatID}`);
  };

  const handleViewAll = () => {
    props.onViewAll(group);
  };

  const handleShareGroup = () => {
    const reportIDs = group.reports.map(report => report._id).join(',');
    const shareUrl = `${window.location.origin}/shared-group?reportIDs=${reportIDs}`;

    // Copy to clipboard
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => {
        // Show success message
        const notification = document.createElement('div');
        notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #10b981;
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        font-family: 'Lato', sans-serif;
        font-weight: 600;
        z-index: 9999;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        animation: slideIn 0.3s ease-out;
      `;
        notification.textContent = 'Share link copied to clipboard!';

        // Add animation styles
        const style = document.createElement('style');
        style.textContent = `
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `;
        document.head.appendChild(style);

        document.body.appendChild(notification);

        // Remove notification after 3 seconds
        setTimeout(() => {
          if (notification.parentNode) {
            notification.parentNode.removeChild(notification);
          }
        }, 3000);
      })
      .catch(() => {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = shareUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        // Show fallback notification
        const notification = document.createElement('div');
        notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #10b981;
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        font-family: 'Lato', sans-serif;
        font-weight: 600;
        z-index: 9999;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        animation: slideIn 0.3s ease-out;
      `;
        notification.textContent = 'Share link copied to clipboard!';

        document.body.appendChild(notification);

        setTimeout(() => {
          if (notification.parentNode) {
            notification.parentNode.removeChild(notification);
          }
        }, 3000);
      });
  };

  return (
    <Box
      sx={{
        alignSelf: 'center',
        '@media (max-width: 600px)': {
          width: '100%',
        },
        '@media only screen and (min-width: 600px) and (max-width: 1023px)': {
          width: '49%',
        },
        '@media only screen and (min-width: 1024px)': {
          width: '32%',
        },
        borderRadius: '1.21144rem',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        marginY: '1rem',
        boxShadow: '5px 20px 30px 0px rgba(229, 229, 229,0.7)',
        backgroundColor: '#ffffff',
      }}
    >
      {/* Top section with visual grouping */}
      <Box
        sx={{
          width: '100%',
          height: '150px',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          backgroundColor: '#f8f9fa',
        }}
      >
        {/* Chat Session Badge */}
        <Box
          sx={{
            position: 'absolute',
            top: '12px',
            left: '12px',
            backgroundColor: '#000000',
            color: '#ffffff',
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '0.75rem',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <MessageSquare size={12} />
          Chat Session
        </Box>

        {/* Stack Badge */}
        <Box
          sx={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            backgroundColor: '#ffffff',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Layers size={16} color='#6b7280' />
          <Box
            sx={{
              position: 'absolute',
              top: '-4px',
              right: '-4px',
              backgroundColor: '#059669',
              color: '#ffffff',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '0.75rem',
              fontWeight: '600',
            }}
          >
            {group.reports.length}
          </Box>
        </Box>

        {/* Google Map Image */}
        <img
          src={
            latestReport?.assets?.maps?.google_map ||
            `https://oldapp.vestmap.com/google_img/${latestReport?.google_image_url}`
          }
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = require('../img/defaultMap.png');
          }}
          alt='Vestmap Default Map'
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>

      {/* Multiple Templates Badge */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '1rem',
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)',
            color: '#ffffff',
            padding: '8px 16px',
            borderRadius: '20px',
            fontSize: '0.875rem',
            fontWeight: '600',
          }}
        >
          Multiple Templates
        </Box>
      </Box>

      {/* Address (Bold) */}
      <Box
        sx={{
          width: '100%',
          padding: '1rem 0',
          textAlign: 'center',
        }}
      >
        <Typography
          variant='h6'
          component='h3'
          textAlign={'center'}
          sx={{
            fontFamily: '"Lato", sans-serif',
            paddingX: '1rem',
            fontSize: '1.25rem',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '140%',
            color: '#323142',
          }}
        >
          {latestReport?.address_info?.address ||
            latestReport?.addressInfo?.address}
        </Typography>
      </Box>

      {/* Chat Session Info */}
      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          marginBottom: '1rem',
          paddingX: '1rem',
        }}
      >
        <Typography
          sx={{
            fontFamily: '"Lato", sans-serif',
            fontSize: '0.875rem',
            color: '#6b7280',
            lineHeight: '1.25rem',
            textAlign: 'center',
          }}
        >
          {group.reports.length} Reports from Chat Session
        </Typography>
        <Typography
          sx={{
            fontFamily: '"Lato", sans-serif',
            fontSize: '0.875rem',
            color: '#6b7280',
            lineHeight: '1.25rem',
            textAlign: 'center',
          }}
        >
          {new Date(
            latestReport?.createdAt || latestReport?.created_at,
          ).toLocaleDateString()}
        </Typography>
      </Box>

      {/* Action Buttons */}
      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          marginBottom: '1.5rem',
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          flexWrap: 'wrap',
        }}
      >
        {AGENT_ENABLED && (
        <Box
          sx={{
            width: '52px',
            height: '3rem',
            border: '2px solid #176a9e',
            borderRadius: '12px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={handleOpenChat}
        >
          <MessageSquare
            style={{
              color: '#176a9e',
            }}
          />
        </Box>
        )}

        <Button
          target='_blank'
          startIcon={<LaunchIcon />}
          variant='outlined'
          size='large'
          onClick={handleViewAll}
          sx={{
            border: '2px solid #39585C',
            borderRadius: '0.75rem',
            color: 'black',
            textTransform: 'capitalize',
            fontFamily: '"Lato", sans-serif',
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '150%',
            ':hover': {
              border: '2px solid #39585C',
              bgcolor: '#39585C',
              color: 'white',
            },
          }}
        >
          View All
        </Button>
        <Box
          sx={{
            width: '52px',
            height: '3rem',
            border: '2px solid #10b981',
            borderRadius: '12px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={handleShareGroup}
        >
          <Share2
            size={20}
            style={{
              color: '#10b981',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

const VestmapBox = props => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [deletionID, setDeletionID] = useState(null);

  async function deleteVestmap(id) {
    try {
      setLoader(true);
      await props.handleDeleteVestmap(id);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }

  return (
    <Box
      key={props.id}
      sx={{
        alignSelf: 'center',
        '@media (max-width: 600px)': {
          width: '100%',
        },
        '@media only screen and (min-width: 600px) and (max-width: 1023px)': {
          width: '49%',
        },
        '@media only screen and (min-width: 1024px)': {
          width: '32%',
        },
        borderRadius: '1.21144rem',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        marginY: '1rem',
        boxShadow: '5px 20px 30px 0px rgba(229, 229, 229,0.7)',
      }}
    >
      {/*   PopUp asking for delete confirmation confirmation */}
      <Dialog
        open={deleteConfirmation}
        onClose={() => {
          setDeletionID(null);
          setDeleteConfirmation(false);
        }}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        PaperProps={{
          sx: {
            borderRadius: '1.25rem',
          },
        }}
      >
        <DialogTitle id='alert-dialog-title'>{'Remove Report'}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to remove this report?{' '}
          </DialogContentText>
        </DialogContent>

        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            onClick={() => {
              setDeletionID(null);
              setDeleteConfirmation(false);
            }}
            sx={{
              color: '#39585C',
              border: '1px solid #39585C',
              borderRadius: '0.75rem',
              height: '2.5rem',
            }}
          >
            No
          </Button>
          <Button
            onClick={async () => {
              console.log('Deleting: ', deletionID);
              deleteVestmap(deletionID);
              setDeleteConfirmation(false);
              setDeletionID(null);
            }}
            color='error'
            sx={{
              border: '1px solid red',
              borderRadius: '0.75rem',
              height: '2.5rem',
              ':hover': {
                bgcolor: 'red',
                color: 'white',
              },
            }}
          >
            {loader ? <CircularProgress size={15} color='error' /> : 'Yes'}
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          width: '100%',
          height: '150px',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={
            props?.record?.assets?.maps?.google_map ||
            `https://oldapp.vestmap.com/google_img/${props?.record?.google_image_url}`
          }
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = require('../img/defaultMap.png');
          }}
          alt='Vestmap Default Map'
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
          }}
        />
      </Box>

      {(props?.record?.template ||
        props?.record?.templateName ||
        props?.record?.templateID) && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '1rem',
          }}
        >
          <Box
            sx={[
              {
                fontFamily: 'Lato',
                fontSize: '1rem',
                padding: '0.5rem 0.5rem 0.5rem 0.5rem',
                borderRadius: '0.7rem',
              },

              props?.record?.template?.theme || props?.record?.theme,
            ]}
          >
            {props?.record?.template?.templateName ||
              props?.record?.templateName ||
              props?.record?.templateID ||
              'Template'}
          </Box>
        </Box>
      )}

      <Box
        sx={{
          width: '100%',
          padding: '1.25rem 0',
          textAlign: 'center',
        }}
      >
        <Typography
          variant='h6'
          component='h3'
          textAlign={'center'}
          sx={{
            fontFamily: '"Lato", sans-serif',
            paddingX: '1rem',
            fontSize: '1.25rem',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '140%',
            color: '#323142',
          }}
        >
          {props?.record?.address_info?.address ||
            props?.record?.addressInfo?.address}
        </Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          marginBottom: '1.5rem',
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
        }}
      >
        {AGENT_ENABLED && props?.record?.chatID && (
          <Box
            sx={{
              width: '52px',
              height: '3rem',
              border: '2px solid #176a9e',
              borderRadius: '12px',

              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (loader) return;
              navigate(`/agent?chatID=${props.record.chatID}`);
            }}
          >
            {loader ? (
              <CircularProgress size={20} color='error' />
            ) : (
              <MessageSquare
                style={{
                  color: '#176a9e',
                }}
              />
            )}
          </Box>
        )}

        <Button
          target='_blank'
          startIcon={<LaunchIcon />}
          variant='outlined'
          size='large'
          onClick={() => props.handleModalOpen(props.record)}
          sx={{
            border: '2px solid #39585C',
            borderRadius: '0.75rem',
            color: 'black',
            textTransform: 'capitalize',
            fontFamily: '"Lato", sans-serif',
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '150%',
            ':hover': {
              border: '2px solid #39585C',
              bgcolor: '#39585C',
              color: 'white',
            },
          }}
        >
          View Report
        </Button>
        <Box
          sx={{
            width: '52px',
            height: '3rem',
            border: '2px solid #D32F2F',
            borderRadius: '12px',

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => {
            if (loader) return;

            setDeletionID(props.record._id);
            setDeleteConfirmation(true);
          }}
        >
          {loader ? (
            <CircularProgress size={20} color='error' />
          ) : (
            <DeleteIconRed />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Content;
